import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5h6a8 8 0 0 1 8 8v6","key":"svg-0"}]]

const IconRadiusTopRight = createReactComponent('outline', 'radius-top-right', 'RadiusTopRight', __iconNode);

export default IconRadiusTopRight;